import { ReportType } from './../../../data/api/types/Report';
import { ContactControllerV2 } from './../ui-contact-controller-v2.service';
import { TemplateFormFields } from './../../ui-shared/form-template/form-template.component';
import { SupportTicketContactController } from './../ui-support-ticket-contact-controller.service';
import {
  Component,
  Input,
  OnInit,
  EventEmitter,
  Output,
  ViewChild,
  OnDestroy,
  inject,
  ChangeDetectorRef,
  TemplateRef,
} from '@angular/core';
import {
  TicketSupportMultimachine,
  UnsavedTicketSupportMultimachine,
  User,
  Status,
  Part,
  UnsavedPart,
  TicketRequestMachine,
  ClientInfo,
} from '@fullyops/legacy/data';
import {
  BehaviorSubject,
  combineLatest,
  defer,
  EMPTY,
  forkJoin,
  Observable,
  of,
  Subscription,
} from 'rxjs';
import { TicketSupportFormService } from './ticket-support-form.service';
import {
  PermissionType,
  Priority,
  PriorityColor,
} from '../../ui-shared/utils/crm-types';
import {
  FormControl,
  FormGroup,
  UntypedFormControl,
  Validators,
} from '@angular/forms';
import { ComponentInOutAnimation } from '../../../../shared/util/component-base-animation';
import { minuteOptions } from '../../../../shared/util/time';
import { assetsTooltipKey } from '@fullyops/shared/assets-tooltip';
import {
  catchError,
  debounceTime,
  map,
  startWith,
  switchMap,
  tap,
} from 'rxjs/operators';
import {
  ALL_FILE_TYPES,
  AttachmentAction,
} from '@fullyops/shared/components/file-upload/component';
import { AttachmentSet } from '@fullyops/shared/attachment-set';
import { FormComponent } from '../../ui-shared/utils/form.component';
import { MatDialog } from '@angular/material/dialog';
import { SupportTicketController } from '../ui-support-ticket-controller.service';
import {
  SupportTicketCategoryResponse,
  SupportTicketRequest,
  SupportTicketResponse,
} from '../../../data/api/types/SupportTicket';
import { ActivatedRoute, Router } from '@angular/router';
import { UiAuthService } from '../ui-auth.service';
import { ContactResponse } from '../../../data/api/types/Contact';
import { Report } from '../../../data/api/types/Report';
import { DialogComponent } from '../../ui-shared/dialog/dialog.component';
import { ReportControllerControllerV2 } from '../ui-report-controller-v2.service';
import { UserResponse } from '../../../data/api/types/User';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { WorkOrderActionsComponent } from '../work-order-action/work-order-actions/work-order-actions.component';
import { diff } from 'deep-object-diff';
import { CountryForm } from '../../../data/models/v0/CountryForm';
import { Country } from '../../../data/models/v0/Country';
import {
  faChartLine,
  faEllipsis,
  faGear,
  faList,
} from '@fortawesome/free-solid-svg-icons';
import { PriorityType } from '../../ui-shared/utils/types';
import { SupportTicketScopeController } from '../ui-support-ticket-scope-v2.service';
import { TicketSupportValidator } from '@fullyops/shared/services/validators/ticket-support-validator.service';
import { AssigneeService } from '@fullyops/shared/services/assignees.service';
import { WorkOrderCategoriesService } from '@fullyops/domain/work-order-categories/services/work-order-categories.service';
import { WorkOrderCategoryUtils } from '@fullyops/shared/util/work-order-categories-utils/work-order-category-utils';
import { ActionTypesService } from '@fullyops/domain/action-types/services/action-types.service';
import { SelectOptionType } from '../../ui-shared/form-select/form-select.component';
import { MomentTimezoneToAngularTimezonePipe } from '@fullyops/shared/pipes/moment-timezone-to-angular-timezone.pipe';
import { faClock } from '@fortawesome/free-regular-svg-icons';
import {
  MatBottomSheet,
  MatBottomSheetRef,
} from '@angular/material/bottom-sheet';
import { KebabMenuItem } from '@fullyops/shared/components/kebab-menu/kebab-menu.component';
import { ToastService } from '@fullyops/shared/services/toast/toast.service';
import { UnsavedChangesDialogComponent } from '@fullyops/shared/components/unsaved-changes-dialog/unsaved-changes-dialog.component';
import { HistoryItem } from '@fullyops/data/history/history';
import {
  ApiWorkOrdersAdapterService,
  isBlockedWithoutMotiveError,
  isCompanyChangeBlockedByInstallationsError,
} from '@fullyops/data/work-orders/api-adapter.service';
import { OverlappingWorkOrder } from '@fullyops/data/work-orders/work-order';
import { MiniAsset } from '@fullyops/data/assets/asset';
import { createInlineAsset } from '@fullyops/shared/create-inline-asset';
import moment from 'moment-timezone';
import { Moment } from 'moment-timezone';
import { ApiTypedTenantConfigurationService } from '@fullyops/data/tenant-configuration/typed-api-adapter';
import { DateTimeRange } from '@fullyops/shared/components/date-time-range-input/date-time-range-input.component';
import { GeolocationService } from '@fullyops/shared/services/geolocation/geolocation.service';
import { MatMenu } from '@angular/material/menu';
import {
  BlockingMotiveDialogComponent,
  BlockingMotiveSelection,
} from '@fullyops/features/work-orders/containers/blocking-motive-dialog/blocking-motive-dialog.component';
import { WorkOrderBlockingMotivesService } from '@fullyops/domain/work-order-blocking-motives/work-order-blocking-motives.service';
import { WorkOrderBlockingMotive } from '@fullyops/data/work-order-blocking-motives/blocking-motives';
import { deleterWithConfirmation } from '@fullyops/shared/deleter-with-confirmation';
import { SidenavPortalBridgeService } from '@fullyops/core/sidenav-form-portal-bridge.service';
import {
  NEW_CONTACT_SIDEBAR_TOKEN,
  NewContactSidebarComponent,
} from '@fullyops/features/contacts/containers/new-contact-sidebar/new-contact-sidebar.component';
import { HttpErrorResponse } from '@angular/common/http';
import { AssetsService } from '@fullyops/domain/assets/service';
import { mapmap } from '@fullyops/shared/observable-pipes';

type InfoTab = FormGroup<{
  name: UntypedFormControl;
  internalRef: UntypedFormControl;
  companyName: FormControl<SupportTicketResponse['company']['name']>;
  clientAddress: FormControl<SupportTicketResponse['company']['address']>;
  clientDistance: FormControl<SupportTicketResponse['company']['distance']>;
  clientEmail: FormControl<SupportTicketResponse['company']['email']>;
  clientPhone: FormControl<SupportTicketResponse['company']['mobileNumber']>;
  contactId: UntypedFormControl;
  malfunctionType: FormControl<SupportTicketResponse['malfunctionType']>;
  zipCode: FormControl<SupportTicketResponse['company']['zipCode']>;
  clientCity: FormControl<SupportTicketResponse['company']['city']>;
  clientTravelTime: FormControl<string>;
  countryISOCode: FormControl<
    SupportTicketResponse['company']['countryISOCode']
  >;
  equipments: FormControl<MiniAsset[]>;
}>;

type DetailsFormGroup = FormGroup<{
  statusId: UntypedFormControl;
  priority: UntypedFormControl;
  plannedDate: FormControl<DateTimeRange>;
  technicianIds: UntypedFormControl;
  category: FormControl<SupportTicketCategoryResponse>;
  scope: UntypedFormControl;
  interventionType: UntypedFormControl;
}>;

enum WorkOrderTabsIndex {
  INFO = 0,
  ACTIONS = 1,
  REQUESTS = 2,
  REPORTS = 3,
  WORK_LOGS = 4,
  HISTORY = 5,
}

@Component({
  selector: 'bottom-sheet-overview-example-sheet',
  templateUrl: './components/bottom-sheet-more-options-mobile.html',
  standalone: false,
})
export class BottomSheetMoreOptionsMobile {
  private _bottomSheetRef =
    inject<MatBottomSheetRef<BottomSheetMoreOptionsMobile>>(MatBottomSheetRef);

  openOption(tabIndex: WorkOrderTabsIndex): void {
    this._bottomSheetRef.dismiss(tabIndex);
  }

  protected readonly WorkOrderTabsIndex = WorkOrderTabsIndex;
}

@Component({
  selector: 'crm-ticket-support-form',
  templateUrl: './ticket-support-form.component.html',
  styleUrls: ['./ticket-support-form.component.scss'],
  providers: [TicketSupportFormService, MomentTimezoneToAngularTimezonePipe],
  animations: [ComponentInOutAnimation.AnimTrigger],
  standalone: false,
})
export class TicketSupportFormComponent
  extends FormComponent<
    TicketSupportMultimachine,
    UnsavedTicketSupportMultimachine,
    TicketSupportFormService
  >
  implements OnInit, OnDestroy
{
  @ViewChild(WorkOrderActionsComponent)
  public workOrderActionsComponent: WorkOrderActionsComponent;

  @ViewChild('companyGeolocationMenuRef', { static: true })
  companyGeolocationMenu!: MatMenu;

  // These are actually TicketSupportMultimachines on first load,
  // and actual SupportTicketResponses after updating at least once.
  // Changing the declared type has enough knock-on effects that it's
  // just not worth it.
  @Input() ticket$: BehaviorSubject<SupportTicketResponse>;
  @Input() ticket: SupportTicketResponse;
  @Input() machines$: BehaviorSubject<TicketRequestMachine[]>;
  @Input() usersParts$: BehaviorSubject<{ [userId: string]: Part[] }>;
  @Input() statuses$: BehaviorSubject<Status[]>;
  @Input() technician$: BehaviorSubject<User[]>;
  @Input() history$: Observable<HistoryItem[]>;
  @Input() generatingReport$: BehaviorSubject<boolean>;
  @Input() showInternalReference: boolean;

  @Output() createRequestEvent =
    new EventEmitter<UnsavedTicketSupportMultimachine>();
  @Output() openRequestEvent = new EventEmitter<string>();
  @Output() createPartEvent = new EventEmitter<UnsavedPart>();
  @Output() requestUserPartsEvent = new EventEmitter<string[]>();

  protected onCreateEquipment() {
    createInlineAsset(
      { sidebar: this.sidebarService, stacked: false },
      {
        interventionType: this.ticket.interventionType,
        requiresUnassignedAsset: this.requiresUnassignedAsset,
        companyId: this.ticket.company?.id ?? null,
      },
    ).subscribe((created) => {
      this.assetRepo.add(created);
      const control = this.infoTabFormGroup.controls.equipments;
      control.setValue([...(control.value ?? []), created]);
      control.markAsDirty();
    });
  }

  protected equipmentsDisplaySelectedOptionLabel(v: MiniAsset): string {
    if (v == null) {
      return '';
    }

    return v.serialNumber ? `[${v.serialNumber}] ${v.name}` : v.name;
  }

  companyContacts$: BehaviorSubject<ContactResponse[]> = new BehaviorSubject<
    ContactResponse[]
  >([]);
  assignees$ = new BehaviorSubject<UserResponse[]>([]);
  reports$: BehaviorSubject<Report[]> = new BehaviorSubject<Report[]>([]);
  countries$ = new BehaviorSubject<CountryForm[]>([]);
  companyGeolocationOptions$ = new BehaviorSubject<
    { providerName: string; url: string }[]
  >([]);

  //  InfoTab
  isSubmitInfoTabDisabled$ = new BehaviorSubject(true);
  protected readonly acceptedFileTypes = ALL_FILE_TYPES;
  protected attachmentSet = new AttachmentSet();
  protected canManageAttachments = this.authService.hasPermissionNoAsync([
    PermissionType.CAN_MANAGE_WORK_ORDER_ATTACHMENTS,
  ]);
  // Attachments live outside infoTabFormGroup, so their dirty state has to be
  // tracked separately and folded into the submit availability below.
  private initialAttachmentIds = new Set<string>();
  infoTabFormGroup: InfoTab = new FormGroup({
    name: new UntypedFormControl('', Validators.required),
    internalRef: new UntypedFormControl(''),
    companyName: new FormControl('', [Validators.required]),
    clientAddress: new FormControl(''),
    clientDistance: new FormControl(null),
    clientTravelTime: new FormControl<string>(null),
    clientEmail: new FormControl(''),
    clientPhone: new FormControl(''),
    contactId: new UntypedFormControl(''),
    malfunctionType: new FormControl('', [Validators.required]),
    zipCode: new FormControl(''),
    clientCity: new FormControl(''),
    countryISOCode: new FormControl(''),
    equipments: new FormControl([], { nonNullable: true }),
  });

  infoTabFormFields: TemplateFormFields<InfoTab>;
  additionalFormFields: TemplateFormFields<any>;
  formDetailsFields: TemplateFormFields<DetailsFormGroup>;
  formDetailsAssignee$ = new BehaviorSubject<{ id: string; name: string }[]>(
    [],
  );

  //  Tracking Form Group
  detailsFormGroup: DetailsFormGroup = new FormGroup({
    statusId: new FormControl(''),
    priority: new FormControl('', Validators.required),
    plannedDate: new FormControl<DateTimeRange | null>(null),
    technicianIds: new UntypedFormControl([]),
    category: new FormControl(null),
    scope: new FormControl('', Validators.required),
    interventionType: new FormControl(
      { value: '', disabled: true },
      Validators.required,
    ),
  });

  // Created at form
  additionalInfoGroup = new FormGroup({
    createdAt: new FormControl({ value: '', disabled: true }, []),
    createdBy: new FormControl({ value: '', disabled: true }, []),
    lastUpdatedAt: new FormControl({ value: '', disabled: true }, []),
  });

  header: string;
  ticketId = '';
  selected: number = 0;

  requestPermissions = [
    PermissionType.CAN_EDIT_REQUEST_TICKETS,
    PermissionType.CAN_EDIT_OWN_REQUEST_TICKETS,
  ];
  reportPermissions = [PermissionType.CAN_EDIT_REPORTS];

  //  For accordion tab index, to set Accordion Tab Index Opened
  accordionOpenedIndex = -1;
  reportType: ReportType = 'SUPPORT_REPORT';

  priorities$ = new BehaviorSubject<{ id: string; name: any; color: any }[]>(
    [],
  );

  private sub: Subscription;

  actionTypesOptions$ = new BehaviorSubject<SelectOptionType[]>([]);

  constructor(
    public ticketSupportMultimachineFormService: TicketSupportFormService,
    protected supportTicketController: SupportTicketController,
    public toastService: ToastService,
    private supportTicketContactController: SupportTicketContactController,
    protected router: Router,
    public authService: UiAuthService,
    protected contactControllerV2: ContactControllerV2,
    public dialog: MatDialog,
    protected reportControllerControllerV2: ReportControllerControllerV2,
    protected ticketSupportValidator: TicketSupportValidator,
    protected route: ActivatedRoute,
    private assigneeService: AssigneeService,
    private actionTypesService: ActionTypesService,
    protected supportTicketScopeController: SupportTicketScopeController,
    private workOrderCategoriesService: WorkOrderCategoriesService,
    private workOrderCategoryUtils: WorkOrderCategoryUtils,
    private datePipe: MomentTimezoneToAngularTimezonePipe,
    private overlapApi: ApiWorkOrdersAdapterService,
    private assetService: AssetsService,
    private typedTenantConfigurationApi: ApiTypedTenantConfigurationService,
    private ref: ChangeDetectorRef,
    private geolocationService: GeolocationService,
    private blockingMotiveService: WorkOrderBlockingMotivesService,
    private sidebarService: SidenavPortalBridgeService,
  ) {
    super(toastService, authService);
    this.initWorkOrderCategories();
    this.actionTypesService.getAll();
    this.sub = this.actionTypesService.actionTypes$
      .pipe(
        map((ats) =>
          ats.map((at) => ({ id: at.label, name: at.label, color: at.color })),
        ),
      )
      .subscribe(this.actionTypesOptions$);
    this.formService = ticketSupportMultimachineFormService;
    this.formEditPermissions = [PermissionType.CAN_EDIT_SUPPORT_TICKETS];
    this.draft$ = new BehaviorSubject<UnsavedTicketSupportMultimachine>(
      new UnsavedTicketSupportMultimachine(
        '',
        '',
        'LOW',
        'BLOCKED',
        [''],
        '',
        [''],
        new ClientInfo('', '', '', '', null, ''),
        '',
        '',
        '',
        '',
        [''],
        new Date(),
        null,
        null,
        null,
        null,
        null,
        '',
        '',
        '',
        '',
        '',
        [],
        null,
        [],
        [],
        '',
        '',
      ),
    );
  }

  protected travelTimeOptions$ = new BehaviorSubject(
    minuteOptions(15, 0, 1425).map((opt) => ({
      id: opt.dayMinute.toString(),
      name: opt.displayText,
    })),
  );

  private assetRepo = this.assetService.createRepository();

  protected equipments$ = this.assetRepo.assets$;
  protected equipmentOptions$: Observable<MiniAsset[]>;

  protected canCreateEquipment = this.authService.hasPermissionNoAsync([
    PermissionType.CAN_EDIT_CLIENT_EQUIPMENTS,
  ]);

  /** Mirrors the tenant flag the picker refresh reads; see onCreateEquipment. */
  private requiresUnassignedAsset = true;

  // Assumes the restriction until the configuration arrives, since that is the
  // tenant default and the field paints before the response.
  protected equipmentsTooltipKey = assetsTooltipKey('INSTALLATION', true);

  initWorkOrderCategories() {
    this.workOrderCategoriesService.get();
  }

  initInfoFormGroupAndFields() {
    if (!this.entity) return;

    this.infoTabFormGroup.reset(
      {
        name: this.ticket$.value.name,
        internalRef: this.ticket$.value.internalRef,
        companyName: this.ticket$.value.company.name,
        clientAddress: this.ticket$.value.clientInfo.address,
        clientDistance: +this.ticket$.value.clientInfo.distance,
        clientTravelTime:
          this.ticket$.value.clientInfo.travelTime != null
            ? this.ticket$.value.clientInfo.travelTime.toString()
            : null,
        clientEmail: this.ticket$.value.company.email,
        clientPhone: this.ticket$.value.company.mobileNumber,
        contactId: this.ticket$.value.contacts.map((contact) => contact.id),
        malfunctionType: this.ticket$.value.malfunctionType,
        zipCode: this.ticket$.value.clientInfo.zipCode,
        clientCity: this.ticket$.value.clientInfo.city,
        countryISOCode: this.ticket$.value.clientInfo.countryISOCode,
        equipments: this.ticket$.value.equipments,
      },
      { emitEvent: false },
    );

    const fieldsToDisable: Array<keyof InfoTab['controls']> = [
      TicketSupportFormComponent.COMPANY_FIELD_NAME,
      'clientEmail',
      'clientPhone',
    ];

    fieldsToDisable.forEach((field) => {
      this.infoTabFormGroup.controls[field].disable();
    });

    if (this.preview) this.infoTabFormGroup.disable();

    this.initAttachments();

    this.infoTabFormGroup.markAsPristine();
  }

  private initAttachments() {
    const attachments = this.ticket$.value.attachments ?? [];
    // Only the saved attachments are re-derived from the work order. A re-init
    // driven by an unrelated update (a blocking motive edit, or a validation
    // failure) must not discard the files the user has picked but not yet
    // uploaded, so the pending previews are carried across untouched.
    const pending = this.attachmentSet.displayedAttachments.filter(
      (a) => a.pending,
    );

    this.attachmentSet.displayedAttachments = [
      ...attachments.map((a) => ({
        id: a.id,
        label: a.fileName,
        pending: false as const,
        file: { fileName: a.fileName, signedUrl: a.url },
      })),
      ...pending,
    ];
    this.initialAttachmentIds = new Set(attachments.map((a) => a.id));
  }

  protected onAttachmentsChange(action: AttachmentAction) {
    this.attachmentSet.update(action);
    this.recomputeInfoTabSubmitAvailability();
  }

  private attachmentsAreDirty(): boolean {
    const current = new Set(
      this.attachmentSet.displayedAttachments
        .filter((a) => !a.pending)
        .map((a) => a.id),
    );

    if (this.attachmentSet.pendingAttachments.length > 0) {
      return true;
    }

    return (
      current.size !== this.initialAttachmentIds.size ||
      [...this.initialAttachmentIds].some((id) => !current.has(id))
    );
  }

  onClickAddContact(): void {
    this.sidebarService.openPortal(
      NewContactSidebarComponent,
      NEW_CONTACT_SIDEBAR_TOKEN,
      {
        company: this.ticket$.value.company,
        onSave: (c: { id: string; name: string }) => {
          // Fetch only the new contact by ID
          this.contactControllerV2.getById(c.id).subscribe((contact) => {
            this.companyContacts$.next([
              ...this.companyContacts$.value,
              contact,
            ]);

            // Add contact ID to form control
            const currentIds = this.infoTabFormGroup.value.contactId || [];
            this.infoTabFormGroup.patchValue({
              contactId: [...currentIds, c.id],
            });
            this.infoTabFormGroup.markAsDirty();

            this.sidebarService.closePortal();
          });
        },
        onCancel: () => this.sidebarService.closePortal(),
      },
    );
  }

  protected overlaps: OverlappingWorkOrder[] = [];

  private updateOverlaps() {
    const { technicianIds, plannedDate } = this.detailsFormGroup.value;
    if (
      technicianIds.length !== 0 &&
      plannedDate != null &&
      !(plannedDate == null && plannedDate.end == null)
    ) {
      this.sub.add(
        this.overlapApi
          .getOverlaps(
            technicianIds,
            toISOString(plannedDate.start),
            toISOString(plannedDate.end),
          )
          .pipe(
            catchError((_) => of<OverlappingWorkOrder[]>([])),
            map((wos) => wos.filter((wo) => wo.id !== this.ticket.id)),
          )
          .subscribe((wos) => {
            this.overlaps = wos;
          }),
      );
    }
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
    this.attachmentSet.clear();
    this.assetRepo.destroy();
    this.blockingMotiveService.clear();
  }

  // this gets clobbered when the blocking motives popup closes...
  protected motives$ = this.blockingMotiveService.motives$;
  protected motiveForm = new FormGroup({
    motive: new FormControl<WorkOrderBlockingMotive>(null),
    notes: new FormControl('', { nonNullable: true }),
  });
  protected motiveSelected$ = defer(() =>
    this.motiveForm.controls.motive.valueChanges.pipe(
      startWith(this.motiveForm.controls.motive.value),
      map((v) => v != null),
    ),
  );

  @ViewChild('blockingMotiveInput', { static: true })
  private blockingMotiveInput: TemplateRef<any>;

  @ViewChild('contactIdInput', { static: true })
  private contactIdInput: TemplateRef<any>;

  canEditContacts$ = this.authService.hasPermission([
    PermissionType.CAN_EDIT_CONTACTS,
  ]);

  contactIdField = {
    name: 'contactId',
    type: 'multiple-select' as const,
    label: 'contacts',
    size: 12,
    items$: this.companyContacts$,
    nullable: false,
    translate: false,
    displayValue: (contact: ContactResponse) => {
      return `${contact.name}  ${
        contact.jobPosition ? `(${contact.jobPosition})` : ''
      }`;
    },
  };

  private companyButtonDisabled$ = new BehaviorSubject<boolean>(true);
  protected schedulingConfig = {
    startWorkingMinute: 0,
    endWorkingMinute: 1440,
  };

  ngOnInit() {
    this.additionalFormFields = [
      { name: 'createdAt', type: 'text', label: 'createdAt', size: 12 },
      { name: 'createdBy', type: 'text', label: 'createdBy', size: 12 },
      { name: 'lastUpdatedAt', type: 'text', label: 'lastUpdatedAt', size: 12 },
    ];
    this.infoTabFormFields = [
      { name: 'name', type: 'text', label: 'title', size: 12 },
      {
        name: 'internalRef',
        type: 'text',
        label: 'internalRef',
        size: 12,
        hidden: !this.showInternalReference,
      },
      {
        name: TicketSupportFormComponent.COMPANY_FIELD_NAME,
        type: 'text',
        label: 'company',
        size: 12,
        buttons: [
          {
            disabled$: this.companyButtonDisabled$,
            iconName: 'account_balance',
            onClick: () => this.navigateToCompanyPage(),
          },
          {
            disabled$: this.companyButtonDisabled$,
            iconName: 'navigation',
            matMenu: this.companyGeolocationMenu,
          },
        ],
      },
      {
        name: 'clientAddress',
        type: 'text',
        label: 'companyAddress',
        size: 9,
      },
      { name: 'clientDistance', type: 'number', label: 'distance', size: 3 },
      { name: 'clientCity', label: 'clientCity', type: 'text', size: 3 },
      {
        name: 'countryISOCode',
        type: 'select',
        label: 'country',
        items$: this.countries$,
        size: 3,
      },
      { name: 'zipCode', label: 'zipCode', type: 'text', size: 3 },
      {
        name: 'clientTravelTime',
        type: 'select',
        label: 'travelTime',
        items$: this.travelTimeOptions$,
        size: 3,
        nullable: true,
      },
      { name: 'clientEmail', type: 'text', label: 'companyEmail', size: 8 },
      { name: 'clientPhone', type: 'text', label: 'companyPhone', size: 4 },
      {
        name: '',
        type: 'template',
        label: '',
        size: 12,
        template: this.contactIdInput,
      },
      /*{
        name: 'equipments',
        type: 'multiple-select',
        label: 'equipments',
        size: 12,
        items$: this.equipments$,
        nullable: false,
        translate: false,
        displayValue: (eq: MiniAsset) => eq.name,
      },*/
      {
        name: 'malfunctionType',
        type: 'textarea',
        label: 'notes',
        size: 12,
      },
    ];

    this.sub.add(
      this.ticket$
        .pipe(map((wo) => wo.company == null))
        .subscribe(this.companyButtonDisabled$),
    );
    // An installation can either bring in a machine from stock or install another
    // one for a company that is already a client — unless the tenant restricts
    // installations to unassigned equipment, leaving stock only. The flag decides
    // which calls to make, so the refresh waits for it to arrive.
    this.sub.add(
      this.typedTenantConfigurationApi
        .getAssetConfig()
        .pipe(
          map((cfg) => cfg.installationRequiresUnassignedAsset),
          // A failed read must not leave the picker unpopulated, so fall back to
          // the tenant default rather than letting the error through.
          catchError(() => of(true)),
        )
        .subscribe((requiresUnassignedAsset) => {
          this.requiresUnassignedAsset = requiresUnassignedAsset;
          // The work order's type is already fixed here, so unlike the creation
          // form this resolves to a single message for the life of the screen.
          this.equipmentsTooltipKey = assetsTooltipKey(
            this.ticket.interventionType,
            requiresUnassignedAsset,
          );

          if (this.ticket.interventionType !== 'INSTALLATION') {
            this.assetRepo.refresh({
              companyId: this.ticket.company.id,
              compatibleWithActionType: this.ticket.interventionType,
            });
          } else if (this.ticket.company != null && !requiresUnassignedAsset) {
            this.assetRepo.refreshInstallable(
              this.ticket.company.id,
              this.ticket.interventionType,
            );
          } else {
            this.assetRepo.refreshUnassigned(this.ticket.interventionType);
          }
        }),
    );
    this.blockingMotiveService.refresh();

    this.initForm();
    this.initInfoFormGroupAndFields();
    this.loadCompanyContacts();
    this.initDetailFormGroupValues();
    this.updateOverlaps();
    this.loadReports();
    this.getCountries();
    this.disableFormIfNotEditPage();

    // This needs to be here because we can't read ticket$ from a regular attribute initializer
    this.equipmentOptions$ = combineLatest([
      this.equipments$,
      this.ticket$,
    ]).pipe(
      map(([es, ticket]) =>
        unassignedFirst(
          unionEquipments(
            ticket.equipments,
            ticket.interventions
              .map((iv) => iv.equipment?.equipment)
              .filter((eq) => eq != null),
            es,
          ),
        ),
      ),
    );

    if (this.entity) {
      this.ticketId = this.entity.id;
    }

    if (!this.entity) {
      this.statuses$
        .pipe(
          map((statuses) => statuses.sort((a, b) => a.position - b.position)),
        )
        .subscribe((statuses) => {
          if (statuses.length) {
            (this.form.get('statusId') as UntypedFormControl).patchValue(
              statuses[0].id,
            );
          }
        });

      (this.form.get('statusId') as UntypedFormControl).disable();
    }

    this.ticketSupportMultimachineFormService.form$.subscribe((form) => {
      this.form = form;

      if (this.entity) {
        const ticketInfoControl = this.form.get(
          'ticketInfo',
        ) as UntypedFormControl;

        (
          this.form
            .get('ticketDetails')
            .get('companyTravelTime') as UntypedFormControl
        ).patchValue(this.entity.company.travelTime);
        (ticketInfoControl.get('clientEmail') as UntypedFormControl).patchValue(
          this.entity.company.email,
        );
        (ticketInfoControl.get('clientPhone') as UntypedFormControl).patchValue(
          this.entity.company.mobileNumber,
        );
      }
    });

    (this.form.get('assigneeId') as UntypedFormControl).valueChanges.subscribe(
      (assignees) => this.requestUserPartsEvent.emit(assignees),
    );

    this.onInfoTabChangeUpdateSummitAvailability();

    this.initPriorities();
    this.initAssignees();
    this.initFormDetailsFields();
    this.sub.add(
      this.typedTenantConfigurationApi
        .getSchedulingConfig()
        .subscribe((cfg) => {
          this.schedulingConfig = cfg;
        }),
    );
    this.onFormDetailsFieldChangePatchData();
    this.ticketSubscription();
  }

  ticketSubscription() {
    this.ticket$.subscribe((ticket) => {
      this.setTicketNameOnBreadCrumb(ticket);
      this.updateAdditionalDataForm(ticket);
      this.loadAssigners(ticket);
      this.loadCompanyGeolocationOptions(ticket);
    });
  }

  updateAdditionalDataForm(ticket: SupportTicketResponse) {
    this.additionalInfoGroup.controls.createdAt.setValue(
      this.datePipe.transform(ticket?.createdAt, 'DD/MM/YYYY HH:mm'),
    );
    this.additionalInfoGroup.controls.lastUpdatedAt.setValue(
      this.datePipe.transform(ticket?.updatedAt, 'DD/MM/YYYY HH:mm'),
    );
    this.additionalInfoGroup.controls.createdBy.setValue(
      this.getCreatedByName(),
    );
  }

  setTicketNameOnBreadCrumb(ticket: SupportTicketResponse) {
    this.route.snapshot.data.breadcrumb = `[WO-${ticket.identifier}] ${ticket.name}`;
  }

  disableFormIfNotEditPage() {
    if (!this.ticket) this.detailsFormGroup.disable();
  }

  initAssignees() {
    this.technician$
      .pipe(
        map((users) => {
          const activeUsers = users.filter((user) => user.active);
          return this.assigneeService.getDropdownAssigneeList({
            formValue: this.ticket?.assignees || [],
            listOfUsers: activeUsers,
          });
        }),
        map((users) =>
          users.map((user) => ({
            id: user.id,
            name: `${user.firstName} ${user.lastName}`,
          })),
        ),
      )
      .subscribe((users) => {
        this.formDetailsAssignee$.next(users);
      });
  }

  getCountries() {
    this.route.data.subscribe((data) => {
      this.countries$.next(
        data?.countries
          .filter((c: Country) => c.active)
          .map((c: Country) => {
            return { countryISOCode: c.isoCode, name: c.name, id: c.isoCode };
          }),
      );
    });
  }

  loadAssigners(ticket: SupportTicketResponse) {
    this.assignees$.next(ticket.assignees);
  }

  loadCompanyGeolocationOptions(ticket: SupportTicketResponse) {
    if (!ticket.company) {
      return;
    }

    this.companyGeolocationOptions$.next(
      this.geolocationService.generateAllUrls(ticket.clientInfo),
    );
  }

  initDetailFormGroupValues() {
    const {
      status,
      priority,
      allDay,
      actAt,
      plannedEndAt,
      category,
      assignees,
      interventionType,
      scope,
    } = this.ticket;

    this.detailsFormGroup.reset(
      {
        statusId: status ? status.id : '',
        priority: priority || '',
        plannedDate: {
          allDay,
          start: actAt != null ? moment(actAt) : null,
          end: plannedEndAt != null ? moment(plannedEndAt) : null,
        },
        technicianIds: assignees ? assignees.map((user) => user.id) : [],
        category: category,
        interventionType: interventionType || '',
        scope: scope || '',
      },
      { emitEvent: false },
    );
    this.motiveForm.reset(
      {
        motive: this.ticket.blockingMotive,
        notes: this.ticket.blockingMotive?.notes,
      },
      { emitEvent: false },
    );
  }

  openTicketRequest(event: string) {
    this.openRequestEvent.emit(event);
  }

  addMachine({ machine, userId }) {
    this.ticketSupportMultimachineFormService.addMachine(machine, userId);
  }

  addPart({ part, userId }) {
    this.ticketSupportMultimachineFormService.addPart(part, userId);
  }

  removePart({ partId, userId }) {
    this.ticketSupportMultimachineFormService.deletePart(partId, userId);
  }

  setAccordionTabIndex(index: number) {
    this.accordionOpenedIndex = index;
  }

  handleTabIndexSwitch(tabIndex: number) {
    const isInfoTabDirty = this.infoTabFormGroup.dirty;

    const openDialog = () => {
      return this.dialog
        .open(DialogComponent, {
          data: {
            title: 'unsavedChangesTitle',
            message: 'unsavedChangesText',
            closeModalText: 'no',
            actionModalText: 'save',
            actionButtonClass: 'button-blue',
            closeButtonClass: 'button-red',
          },
        })
        .afterClosed();
    };

    // this never actually worked!
    /*
    if (dirtyActionForms?.length > 0) {
      if (tabIndex !== 2) {
        openDialog().subscribe((saveOutput) => {
          if (!saveOutput) {
            //reset form
            return dirtyActionForms.forEach((form) => form.initFormValues());
          } else {
            //save dirty interventions
            dirtyActionForms.forEach((actionForm) => {
              actionForm.onSubmit();
              if (!actionForm.formGroup.valid) {
                this.selected = 2;
                setTimeout(() => {
                  actionForm.scrollToInvalidControl();
                }, 200);
              }
            });
          }
        });
      }
    }*/

    if (isInfoTabDirty) {
      if (tabIndex !== 0) {
        openDialog().subscribe((save) => {
          if (!save) {
            this.initInfoFormGroupAndFields();
            return false;
          } else {
            this.infoTabFormGroup.markAllAsTouched();
            //save dirty form
            if (this.infoTabFormGroup.valid) {
              this.updateTicket({});
            } else {
              this.selected = 0;
            }
            return true;
          }
        });
      }
    }
  }

  onTabClick(event: MatTabChangeEvent) {
    this.handleTabIndexSwitch(event.index);
  }

  updateSelectedTab(tabIndex: number) {
    this.selected = tabIndex;
  }

  openRequestTab() {
    this.selected = WorkOrderTabsIndex.REQUESTS;
  }

  loadCompanyContacts() {
    this.contactControllerV2
      .getAll({
        queryParams: { companyId: this.ticket$.value.company.id },
      })
      .subscribe((res) => {
        this.companyContacts$.next(res.results);
      });
  }

  loadReports() {
    return this.reportControllerControllerV2
      .getTicketReports({
        reportType: this.reportType,
        ticketId: this.ticket.id,
      })
      .subscribe((res) => this.reports$.next(res.results));
  }

  async updateTicket({ isDetailFormUpdate }: { isDetailFormUpdate?: boolean }) {
    if (this.preview) return;
    if (!this.infoTabFormGroup.valid) {
      return this.toastService.showInvalidFieldsFormErrorMessage();
    }

    const newData: SupportTicketRequest = {
      actAt: toISOString(
        this.detailsFormGroup.controls.plannedDate.value.start,
      ),
      plannedEndAt: toISOString(
        this.detailsFormGroup.controls.plannedDate.value.end,
      ),
      allDay: this.detailsFormGroup.controls.plannedDate.value.allDay,
      priority: this.detailsFormGroup.get('priority').value as PriorityType,
      statusId: this.detailsFormGroup.get('statusId').value,

      clientInfo: {
        address: this.infoTabFormGroup.controls['clientAddress'].value,
        distance:
          this.infoTabFormGroup.controls['clientDistance'].value?.toString(),
        travelTime: this.infoTabFormGroup.controls['clientTravelTime'].value
          ? +this.infoTabFormGroup.controls['clientTravelTime'].value
          : null,
        city: this.infoTabFormGroup.controls['clientCity'].value,
        countryISOCode: this.infoTabFormGroup.controls['countryISOCode'].value,
        zipCode: this.infoTabFormGroup.controls['zipCode'].value,
      },
      equipmentIds: this.infoTabFormGroup.controls.equipments.value.map(
        (e) => e.id,
      ),
      closedAt: this.ticket.closedAt,
      companyId: this.ticket.company.id, // As company will never change
      createdAt: this.ticket.createdAt,
      executedAt: this.ticket.executedAt,
      finished: this.ticket.finished,
      id: this.ticket.id,
      malfunctionType: this.infoTabFormGroup.get('malfunctionType').value,
      name: this.infoTabFormGroup.get('name').value,
      internalRef: this.infoTabFormGroup.get('internalRef').value,
      categoryId: this.detailsFormGroup.controls.category.value
        ? this.detailsFormGroup.controls.category.value.id
        : null,
      interventionType:
        this.detailsFormGroup.controls['interventionType'].value,
      scope: this.detailsFormGroup.controls['scope'].value,
      assigneeIds: this.detailsFormGroup.controls['technicianIds'].value || [],
      // Only send this when the user may manage attachments: its presence is what
      // makes the back end require CAN_MANAGE_WORK_ORDER_ATTACHMENTS.
      ...(this.canManageAttachments
        ? {
            attachmentIds: this.attachmentSet.displayedAttachments
              .filter((a) => !a.pending)
              .map((a) => a.id),
          }
        : {}),
    };

    const validationResponse =
      await this.ticketSupportValidator.validateBeforeUpdate({
        previousSupportTicketData: this.ticket,
        newSupportTicketData: newData,
        interventions: this.ticket.interventions,
        reports: this.reports$.value,
        statuses: this.statuses$.value,
        workPeriods: this.ticket.workPeriods,
      });

    //If there is some value, means some field are not valid
    if (Object.keys(validationResponse).length > 0) {
      this.initDetailFormGroupValues();
      this.initInfoFormGroupAndFields();
      return;
    }

    const oldContactIds = this.ticket.contacts.map((contact) => contact.id);
    const newContactIds: string[] =
      this.infoTabFormGroup.get('contactId').value;

    const contactsToAdd = newContactIds.filter((newContactId) => {
      return !oldContactIds.includes(newContactId);
    });

    const contactsToRemove = oldContactIds.filter((oldContactId) => {
      return !newContactIds.includes(oldContactId);
    });

    const contactsToRemoveRequests = contactsToRemove.map((contactId) => {
      return this.supportTicketContactController.delete({
        contactId,
        supportTicketId: this.ticket.id,
      });
    });

    const contactsToAddRequests = contactsToAdd.map((contactId) => {
      return this.supportTicketContactController.create({
        contactId,
        supportTicketId: this.ticket.id,
      });
    });

    const updateTicketRequest =
      this.supportTicketController.updateSupportTicket({
        ticketId: this.ticket.id,
        data: newData,
      });

    if (
      contactsToRemoveRequests.length == 0 &&
      contactsToAddRequests.length == 0
    ) {
      const tryUpdate = (req: Observable<SupportTicketResponse>) => {
        req.subscribe(
          (ticketResponse) => {
            this.uploadPendingAttachments(ticketResponse).subscribe((t) =>
              this.setUpdatedTicket(t),
            );
          },
          async (err: HttpErrorResponse) => {
            if (isBlockedWithoutMotiveError(err)) {
              const motive = await this.promptForBlockingMotive();
              if (motive == null) {
                this.initDetailFormGroupValues();
                return;
              }
              tryUpdate(
                this.supportTicketController.updateSupportTicket({
                  ticketId: this.ticket.id,
                  data: {
                    ...newData,
                    blockingMotive: {
                      id: motive.motive.id,
                      notes: motive.notes,
                    },
                  },
                }),
              );
            } else if (isCompanyChangeBlockedByInstallationsError(err)) {
              this.onCompanyChangeBlockedByInstallations();
            } else if (isDetailFormUpdate) {
              this.initDetailFormGroupValues();
            }
          },
        );
      };
      tryUpdate(updateTicketRequest);
    } else {
      forkJoin(...contactsToRemoveRequests, ...contactsToAddRequests).subscribe(
        () => {
          updateTicketRequest.subscribe(
            (ticketResponse) => {
              this.uploadPendingAttachments(ticketResponse).subscribe((t) => {
                this.ticket$.next(t);
                this.updateOverlaps();
                this.initInfoFormGroupAndFields();
                this.isSubmitInfoTabDisabled$.next(true);
              });
            },
            (err: HttpErrorResponse) => {
              if (isCompanyChangeBlockedByInstallationsError(err)) {
                this.onCompanyChangeBlockedByInstallations();
              } else if (isDetailFormUpdate) {
                this.initDetailFormGroupValues();
              }
            },
          );
        },
      );
    }
  }

  // The refusal itself is reported by the error interceptor. The work order keeps
  // its company, so the form has to go back to showing it.
  private onCompanyChangeBlockedByInstallations() {
    this.initInfoFormGroupAndFields();
  }

  // Newly attached files can only be uploaded once the work order is saved, since
  // the upload endpoint attaches them to an existing work order. The work order is
  // then re-fetched so that the attachment list picks up the server-side metadata.
  private uploadPendingAttachments(
    ticket: SupportTicketResponse,
  ): Observable<SupportTicketResponse> {
    const pending = this.attachmentSet.pendingAttachments;
    if (pending.length === 0) {
      return of(ticket);
    }

    return this.supportTicketController
      .attachFiles({ ticketId: ticket.id, files: pending })
      .pipe(
        tap(() => this.dropPendingPreviews()),
        catchError(() => {
          // The work order itself saved; only the upload failed. Report that and
          // complete without emitting, so that the caller does not reset the form
          // and the picked files stay on screen for the user to retry with.
          this.toastService.showTranslatedErrorMessage(
            'attachmentUploadFailed',
          );
          return EMPTY;
        }),
        switchMap(() =>
          this.supportTicketController.getSupportTicketById(ticket.id).pipe(
            // The files did attach, so there is nothing to report here; the list
            // just catches up on the next load of the work order.
            catchError(() => EMPTY),
          ),
        ),
      );
  }

  // Once the picked files are uploaded, their local previews have to go before
  // the re-fetch above brings them back as regular attachments; leaving them in
  // place would show every newly attached file twice.
  private dropPendingPreviews(): void {
    this.attachmentSet.displayedAttachments =
      this.attachmentSet.displayedAttachments.filter((at) => {
        if (at.pending) {
          URL.revokeObjectURL(at.file.signedUrl);
        }
        return !at.pending;
      });
  }

  private async promptForBlockingMotive(): Promise<BlockingMotiveSelection | null> {
    return new Promise((resolve, reject) => {
      this.dialog
        .open(BlockingMotiveDialogComponent)
        .afterClosed()
        .subscribe({
          next: (result) => {
            this.blockingMotiveService.refresh();
            resolve(result);
          },
          error: reject,
        });
    });
  }

  navigateToCompanyPage() {
    const go = () => {
      this.sub.add(
        this.authService
          .hasPermission([PermissionType.CAN_EDIT_COMPANIES])
          .subscribe((canEditCompanies) => {
            return this.router.navigate([
              `companies/${this.ticket$.value.company.id}${
                canEditCompanies ? '/edit' : ''
              }`,
            ]);
          }),
      );
    };

    if (this.isSubmitInfoTabDisabled$.value) {
      go();
      return;
    }

    this.sub.add(
      this.dialog
        .open(UnsavedChangesDialogComponent)
        .afterClosed()
        .subscribe((confirmed) => {
          if (confirmed) {
            go();
          }
        }),
    );
  }

  protected kebabItems: KebabMenuItem[] = [
    { label: 'delete', highlight: 'warn', action: () => this.onDelete() },
  ];

  onDelete = deleterWithConfirmation(
    () =>
      this.supportTicketController.deleteSupportTicketById({
        ticketId: this.ticket.id,
      }),
    ['../..'],
  );

  private setUpdatedTicket(ticket: SupportTicketResponse): void {
    this.ticket$.next(ticket);
    if (ticket.blockingMotive == null) {
      this.motiveForm.reset(undefined, { emitEvent: false });
    } else {
      this.motiveForm.reset(
        { motive: ticket.blockingMotive, notes: ticket.blockingMotive.notes },
        { emitEvent: false },
      );
    }
    this.updateOverlaps();
    this.initInfoFormGroupAndFields();
    this.isSubmitInfoTabDisabled$.next(true);
  }

  onInfoTabChangeUpdateSummitAvailability() {
    this.infoTabFormGroup.valueChanges.subscribe(() =>
      this.recomputeInfoTabSubmitAvailability(),
    );
  }

  private recomputeInfoTabSubmitAvailability() {
    const newValue = this.infoTabFormGroup.value;
    const originalValues = {};
    const supportTicket = this.ticket$.value;
    const { clientInfo, contacts } = supportTicket;

    Object.keys(newValue).forEach((key) => {
      if (key == 'clientAddress') {
        return (originalValues[key] = clientInfo.address);
      }

      if (key == 'clientDistance') {
        return (originalValues[key] = clientInfo.distance);
      }

      if (key == 'clientTravelTime') {
        return (originalValues[key] =
          clientInfo.travelTime != null
            ? clientInfo.travelTime.toString()
            : null);
      }

      if (key == 'contactId') {
        return (originalValues[key] = contacts.map((u) => u.id));
      }

      //  Prevent differences btw null and undefined
      if (!newValue[key] && !supportTicket[key]) {
        return (originalValues[key] = newValue[key]);
      }

      originalValues[key] = supportTicket[key];
    });

    const differences = diff(originalValues, newValue);

    if (Object.keys(differences).length == 0 && !this.attachmentsAreDirty()) {
      if (!this.isSubmitInfoTabDisabled$.value)
        this.isSubmitInfoTabDisabled$.next(true);
    } else {
      if (this.isSubmitInfoTabDisabled$.value)
        this.isSubmitInfoTabDisabled$.next(false);
    }
  }

  initPriorities() {
    const pro = Object.keys(Priority).map((key) => ({
      id: key,
      name: Priority[key],
      color: PriorityColor[key],
    }));
    this.priorities$.next(pro);
  }

  @ViewChild('plannedDateInput', { static: true })
  private plannedDateInput: TemplateRef<any>;

  initFormDetailsFields() {
    this.formDetailsFields = [
      {
        name: 'statusId',
        type: 'select',
        label: 'status',
        size: 6,
        items$: this.statuses$,
        nullable: false,
        translate: true,
        dataTestId: 'status-select-cypress',
      },
      {
        name: 'priority',
        type: 'select',
        label: 'priority',
        size: 6,
        items$: this.priorities$,
        nullable: false,
        translate: true,
        dataTestId: 'priority-test',
      },
      {
        name: '',
        type: 'template',
        label: '',
        size: 12,
        template: this.blockingMotiveInput,
      },
      {
        name: '',
        type: 'template',
        label: '',
        size: 12,
        template: this.plannedDateInput,
      },
      {
        name: 'technicianIds',
        type: 'multiple-select',
        label: 'assignee',
        size: 12,
        items$: this.formDetailsAssignee$,
        translate: false,
        dataTestId: 'technicianIds-test',
      },
      {
        name: 'interventionType',
        type: 'select',
        label: 'actionType',
        size: 6,
        items$: this.actionTypesOptions$,
        translate: true,
        matTooltip: 'cantChangeActionType',
      },
      {
        name: 'scope',
        type: 'select',
        label: 'scope',
        size: 6,
        items$: this.supportTicketScopeController.getScopesSelectOptions$(),
        translate: true,
      },
      {
        name: 'category',
        type: 'autocomplete',
        label: 'category',
        size: 12,
        items$: this.workOrderCategoryUtils.getOptions$(),
      },
    ];
  }

  onFormDetailsFieldChangePatchData() {
    this.detailsFormGroup.valueChanges.subscribe((e) => {
      if (this.detailsFormGroup.valid) {
        this.updateTicket({ isDetailFormUpdate: true });
      }
    });
    this.motiveForm.controls.motive.valueChanges.subscribe((motive) => {
      if (motive == null) {
        this.motiveForm.controls.notes.reset('', { emitEvent: false });
      }
      this.supportTicketController
        .updateSupportTicket({
          ticketId: this.ticketId,
          data: {
            blockingMotive:
              motive == null
                ? null
                : {
                    id: motive.id,
                    notes: this.motiveForm.controls.notes.value,
                  },
          },
        })
        .subscribe((t) => this.setUpdatedTicket(t));
    });
    this.motiveForm.controls.notes.valueChanges
      .pipe(debounceTime(500))
      .subscribe((notes) => {
        const motive = this.motiveForm.controls.motive.value;
        if (motive == null) {
          return;
        }
        this.supportTicketController
          .updateSupportTicket({
            ticketId: this.ticketId,
            data: { blockingMotive: { id: motive.id, notes } },
          })
          .subscribe((t) => this.setUpdatedTicket(t));
      });
  }

  getCreatedByName() {
    const { firstName, lastName } = this.ticket$.value.createdBy || {};
    if (firstName || lastName) return `${firstName} ${lastName}`;
    return '';
  }

  openBottomSheet(): void {
    const ref = this._bottomSheet.open(BottomSheetMoreOptionsMobile, {
      restoreFocus: true,
      autoFocus: false,
    });
    ref.afterDismissed().subscribe((tabIndex) => {
      if (!tabIndex) {
        return;
      }

      this.updateSelectedTab(tabIndex);
      this.ref.detectChanges();
    });
  }

  openUrlInNewTab(url: string): void {
    window.open(url, '_blank');
  }

  protected readonly faList = faList;
  protected readonly faClock = faClock;
  protected readonly faGear = faGear;
  protected readonly faChartLine = faChartLine;
  protected readonly faEllipsis = faEllipsis;

  private _bottomSheet = inject(MatBottomSheet);
  protected readonly WorkOrderTabsIndex = WorkOrderTabsIndex;

  private static COMPANY_FIELD_NAME = 'companyName' as const;
}

// form-date can have either a Moment or a string as its value, so we must handle
// both.
function toISOString(v: Moment | string): string {
  return typeof v === 'string' ? v : v == null ? null : v.toISOString();
}

/**
 * Unassigned machines first, since installing one the client already has is the
 * exception. The sort is stable, so each group keeps the name ordering the back
 * end returned, and equipments with no ownership tag — those already on the work
 * order — stay where the union put them relative to the assigned ones.
 */
function unassignedFirst(equipments: MiniAsset[]): MiniAsset[] {
  return [...equipments].sort((a, b) => ownershipRank(a) - ownershipRank(b));
}

function ownershipRank(equipment: MiniAsset): number {
  return equipment.ownership === 'UNASSIGNED' ? 0 : 1;
}

function unionEquipments(...sources: MiniAsset[][]): MiniAsset[] {
  const uniqueEquipments: { [id: string]: MiniAsset } = Object.create(null);
  for (const s of sources) {
    for (const eq of s) {
      uniqueEquipments[eq.id] = eq;
    }
  }
  const union: MiniAsset[] = [];
  for (const id in uniqueEquipments) {
    union.push(uniqueEquipments[id]);
  }
  return union;
}
